import { Icon, IconTypes, Text, HStack, Stack } from '@genial/components';
import { BoxBorder, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Skeleton } from 'native-base';
import React from 'react';

import { CustomerDuckRightIcon } from '../CustomerDuckRightIcon';

interface CustomerDuckProductEnableProps {
  description: string;
  enabled: boolean;
  icon: IconTypes.Props;
}

export const CustomerDuckProductEnable: React.FC<CustomerDuckProductEnableProps> = ({
  description,
  enabled,
  icon,
}) => {
  const isMobile = useBreakpointValue({ base: true, sm: false });

  return (
    <Stack
      space="stack.nano"
      direction={isMobile ? 'row' : 'column'}
      alignItems={isMobile ? 'center' : undefined}>
      <Icon {...icon} />
      <HStack space="inline.quarck" alignItems="center">
        <Text
          textTransform="uppercase"
          fontSize={Typography['fontsize.lg']}
          variant="semibold"
          color={enabled ? 'neutral.black' : 'neutral.light'}>
          {description}
        </Text>
        <CustomerDuckRightIcon type={enabled ? 'success' : 'blocked'} />
      </HStack>
    </Stack>
  );
};

export const CustomerDuckProductEnableLoading: React.FC = () => {
  const isMobile = useBreakpointValue({ base: true, sm: false });

  return (
    <Stack
      space="stack.nano"
      direction={isMobile ? 'row' : 'column'}
      alignItems={isMobile ? 'center' : undefined}>
      <Skeleton width={12} height={12} borderRadius={BoxBorder.heavy} />
      <HStack space="inline.quarck" alignItems="center" flex={1}>
        <Text flex={1} maxW="1/2" isLoading>
          Loading
        </Text>
        <Skeleton width={4} height={4} borderRadius={BoxBorder.heavy} />
      </HStack>
    </Stack>
  );
};
